export const GET_COUNTRIES = "GET_COUNTRIES";
export const UPDATE_COUNTRY_STATUS = "UPDATE_COUNTRY_STATUS";
